import { queryOptions } from '@tanstack/react-query'
import {
  AcctAttestationTextResponse,
  ApplicationResponse,
  GETAttestationText,
  GETCompetingPrograms,
  GETScholarshipApplication,
} from '@/queries/family_applications/requests'
import { CustomQueryOptions } from '@/common/types_and_interfaces.ts'

export const FamilyApplicationQueryKeys = {
  getApplication: (scholarship_applications_id: number | null) => [
    'getApplication',
    scholarship_applications_id,
  ],
  global_programs: (programId: number) => ['global_programs', programId],
  attestations_text: ['attestations_text'],
} as const

export class FamilyApplicationQueries {
  public static getScholarApplicationDetails(
    scholarship_applications_id: number | null,
    options: CustomQueryOptions<ApplicationResponse> = {}
  ) {
    return queryOptions({
      queryKey: FamilyApplicationQueryKeys.getApplication(
        scholarship_applications_id
      ),
      queryFn: () => GETScholarshipApplication(scholarship_applications_id),
      staleTime: 1,
      ...options,
    })
  }

  public static getCompetingPrograms(programID: number) {
    return queryOptions({
      queryKey: FamilyApplicationQueryKeys.global_programs(programID),
      queryFn: () => GETCompetingPrograms(programID),
    })
  }

  public static fetchAcctAttestationsText(
    programID: number,
    options: CustomQueryOptions<AcctAttestationTextResponse[]> = {}
  ) {
    return queryOptions({
      queryKey: FamilyApplicationQueryKeys.attestations_text,
      queryFn: () => GETAttestationText(programID),
      ...options,
    })
  }
}
